<template>
  <div class="page-content skip-whitespace">
    <div class="page-background background-karriere" />

    <section class="transparent">
      <div class="container">
        <h3 class="text-center pb-8">
          Zur Verstärkung unseres Teams suchen wir<br/>
          <strong>ab sofort</strong>
        </h3>
        <h3 class="text-center">eine/n</h3>

        <h1>Schneidergesellin/en und Schneidermeister/in</h1>
        <h2>in VOLLZEIT</h2>
        <p class="leading-normal mx-auto">
          IHRE AUFGABEN
          <ul>
            <li>Sie fertigen nach Vorgaben von Anfang bis Ende Einzelanfertigungen unserer Kunden</li>
            <li>Sie wirken bei der Erstellung der Musterkollektion mit</li>
            <li>Sie unterstützen bei der Lehrlingsbetreuung</li>
          </ul>
        </p>

        <p class="leading-normal mx-auto">
          DAS IDEALE PROFIL
          <ul>
            <li>Sie haben eine erfolgreich abgeschlossene Berufsausbildung als Schneidergeselle/in</li>
            <li>Sie haben Berufserfahrung im Couture Schneiderhandwerk</li>
            <li>Sie verfügen über eine strukturierte und organisierte Arbeitsweise</li>
            <li>Sie arbeiten effizient und ergebnisorientiert</li>
            <li>Sie lieben es hochwertige Stoffe zu verarbeiten</li>
            <li>Sie lieben es im Team zu arbeiten</li>
          </ul>
        </p>
        <p>
          WIR BIETEN
          <ul>
            <li>Eine interessante, anspruchsvolle und abwechslungsreiche Tätigkeit</li>
            <li>Eine offene und familiäre Arbeitsatmosphäre</li>
            <li>Übertarifliche Konditionen</li>
            <li>Betriebliche Altersvorsorge</li>
            <li>Diverse zusätzliche Benefits</li>
            <li>Einen sicheren und langfristigen Arbeitsplatz</li>
            <li>Einen Top Arbeitgeber mit sehr gutem Ruf und sozialem Engagement</li>
          </ul>
        </p>
        <p>Über Ihre aussagekräftigen Bewerbungsunterlagen mit Angabe des frühestmöglichen Eintrittstermins freuen wir uns sehr!</p>
        <p class="mt-10">
          Gabriele Blachnik GmbH & Co. KG<br>
          Marstallstr.8, 80539 München<br>
          Telefon: 089/2421889-0<br>
          E-Mail: info@gabriele-blachnik.de
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Karriere',
      meta: [
        {
          'name': 'description',
          'content': 'Über Ihre aussagekräftigen Bewerbungsunterlagen mit Angabe des frühestmöglichen Eintrittstermins freuen wir uns.'
        }
      ]
    }
  }
</script>

<style lang="postcss" scoped>
  ul {
    @apply pl-8;
    @apply list-disc list-outside;

    li {
      @apply py-1;
    }
  }
</style>
